import { Icon, Typography } from "@/components/atoms";

export const InviteWarningStep = () => {
  return (
    <div className="flex flex-col gap-5">
      <div className="flex flex-col gap-3 rounded-lg border border-neutral-mid-gray p-4">
        <div className="flex items-center gap-3">
          <Icon name="TickCircle" variant="Bold" className="flex-shrink-0 text-success" />
          <Typography variant="paragraph" className="text-success">
            Only invite providers you directly work with and trust.
          </Typography>
        </div>
        <div className="flex items-center gap-3">
          <Icon name="CloseCircle" variant="Bold" className="flex-shrink-0 text-danger" />
          <Typography variant="paragraph" className="text-danger">
            Do not invite operators you don&apos;t have an existing relationship with, they will likely block you permanently.
          </Typography>
        </div>
      </div>
      <Typography variant="paragraph" className="text-neutral-dark-gray">
        Are you inviting a provider that you have an established working relationship with to your private network?
      </Typography>
    </div>
  );
};
